import React from "react";
import { useSite } from "../context/SiteContext";
import useReveal from "../hooks/useReveal";

export default function Origins() {
  useReveal();
  const { c } = useSite();
  const { origins } = c;
  return (
    <section id="origins" className="bg-ink py-28 sm:py-40">
      <div className="max-w-[1220px] mx-auto px-5 sm:px-8">
        <div className="max-w-3xl">
          <div className="flex items-center gap-4 mb-7">
            <span className="eyebrow">{origins.label}</span>
          </div>
          <h2 className="font-display text-4xl sm:text-6xl font-light leading-[1.02] text-parchment">
            {origins.title}
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-px mt-20 bg-[var(--c-border)]">
          {origins.cards.map((c, i) => (
            <div
              key={c.n}
              className="reveal bg-ink px-8 py-12 group hover:bg-ink2 transition-colors duration-500"
              style={{ animationDelay: `${i * 120}ms` }}
            >
              <p className="eyebrow mb-8 text-stone2">{origins.kicker}</p>
              <span className="font-display text-7xl font-light text-gold/40 group-hover:text-gold/80 transition-colors duration-500">
                {c.n}
              </span>
              <h3 className="font-display text-3xl font-medium text-parchment mt-6">{c.title}</h3>
              <p className="mt-4 text-lg leading-relaxed text-parchment/65 font-light">{c.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
